import React, {useState, useEffect} from "react";
import OwlCarousel from 'react-owl-carousel2';
import 'react-owl-carousel2/src/owl.carousel.css';
import 'react-owl-carousel2/src/owl.theme.default.css';
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './latestListing.module.css';

let background1 = require('../images/listing-1.png').default;
let background2 = require('../images/listing-2.png').default;
let background3 = require('../images/listing-3.png').default;

let owlClass = "listing-owl " + styles.listingWrap;

const options = {
    items: 3,
    nav: false,
    dots: false,
    rewind: false,
    autoplay: true,
    autoplayTimeout: 10000,
    margin: 17,
    responsive : {
        0 : {
            items: 1,
            stagePadding: 30
        },
        900 : {
            items: 3,
            stagePadding: 0
        }
    }
};

function LatestListing(props) {

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [listing, setListing] = useState([]);

    useEffect(() => {
        fetch("http://homesta-dev.ap-southeast-2.elasticbeanstalk.com/api/v1.0/public/properties/latest")
            .then(res => res.json())
            .then(
                (result) => {
                setIsLoaded(true);
                setListing(result);
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )
    }, []);

    var formatter = new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
      
        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });
    
    let bgcolor = (props.bgcolor) ? props.bgcolor.hex : '#FFFFFF';
    let bgColorbot = (props.bgcolorbot) ? props.bgcolorbot.hex : '#FFFFFF';

    if(isLoaded && listing.properties && !error){

        return (
            <div className={styles.sectionLatestListing} style={{ backgroundColor: `${bgcolor}`}}>
                <div className={styles.sectionContent}>
                    <div class="container mx-auto">
                        <h3>{props.heading}</h3>
                        <div className={owlClass}>

                            <OwlCarousel options={options}>

                                {
                                    listing.properties.map((item, i) => {  

                                        item.key = 'key-'+i;

                                        let display_address = (item.short_address) ? item.short_address+', '+item.city : item.full_address;
                                        let bath_count = (item.bath_count) ? item.bath_count : 'N/A';
                                        let bed_count = (item.bed_count) ? item.bed_count : 'N/A';
                                        let car_space_count = (item.car_space_count) ? item.car_space_count : 'N/A';

                                        let item_image = (item.property_assets.length > 0) ? item.property_assets[0].asset.url : background1;
                                        
                                        let isSamePrice = (item.from_price == item.to_price);
                                        let from_price = formatter.format((item.from_price/100));
                                        let to_price =  formatter.format((item.to_price/100)) ;
                                        let range_price = from_price + ' - ' + to_price;
                                        let display_price = (isSamePrice) ? from_price : range_price;
                                        display_price = (display_price == '$0.00') ? 'Price not available' : display_price;

                                        return (
                                            <div className={styles.listingItem} key={item.key}>
                                                <div className={styles.itemImage} style={{ backgroundImage: `url('${item_image}')` }}></div>
                                                <div className={styles.itemDetails}>
                                                    <h4>{display_price}</h4>
                                                    <h5>{item.full_address}</h5>
                                                    <div className={styles.iconsBar}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="28.699" height="19.719" viewBox="0 0 28.699 19.719">
                                                            <path id="Path_19970" data-name="Path 19970" d="M236.679,962.38H234.87v-8.74a1.282,1.282,0,0,0-1.275-1.275H213.617a1.281,1.281,0,0,0-1.275,1.275v8.74h-1.817a1.281,1.281,0,0,0-1.275,1.275v5.12a1.283,1.283,0,0,0,1.275,1.276h1.225v1.168a.835.835,0,0,0,1.669.05v-1.212h20.362v1.168a.835.835,0,0,0,1.669.05v-1.218h1.225a1.281,1.281,0,0,0,1.274-1.275v-5.124a1.281,1.281,0,0,0-1.27-1.278m-22.672-8.346H233.2v8.346h-2.67v-.7a2.644,2.644,0,0,0-2.641-2.642h-8.572a2.643,2.643,0,0,0-2.643,2.641v.7h-2.668Zm14.854,7.65v.7H218.346v-.7a.975.975,0,0,1,.975-.975h8.572a.975.975,0,0,1,.968.972Zm7.425,6.706H210.919v-4.342h25.369Z" transform="translate(-209.25 -952.365)" fill="#002a3f"/>
                                                        </svg>
                                                        <span>{bed_count}</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="21.989" height="21.62" viewBox="0 0 21.989 21.62">
                                                            <path id="Path_19971" data-name="Path 19971" d="M286.5,960.606v5.586a4.532,4.532,0,0,0,4.092,4.5v.132A2.4,2.4,0,0,0,293,973.214h8.991a2.4,2.4,0,0,0,2.407-2.392v-.134a4.533,4.533,0,0,0,4.093-4.5v-5.586h-2.915v-4.974a4.04,4.04,0,0,0-8.079,0v1.037H299.1v-1.037a2.434,2.434,0,0,1,4.869,0v4.975Zm15.489,11.013H293a.8.8,0,0,1-.8-.8v-.106h10.593v.106a.8.8,0,0,1-.8.8m4.895-5.426a2.935,2.935,0,0,1-2.943,2.925H291.048a2.935,2.935,0,0,1-2.943-2.925V962.2h18.78Z" transform="translate(-286.5 -951.594)" fill="#002a3f"/>
                                                        </svg>
                                                        <span>{bath_count}</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="26.498" height="20.61" viewBox="0 0 26.498 20.61">
                                                            <path id="Path_19967" data-name="Path 19967" d="M383.409,959.063a17.914,17.914,0,0,0-1.3-4.95,4.032,4.032,0,0,0-3.738-2.5h-13.25a4,4,0,0,0-3.74,2.5,17.912,17.912,0,0,0-1.3,4.95,2.218,2.218,0,0,0-1.59,2.117v5.888a.729.729,0,0,0,.722.736h.75v3.682a.728.728,0,0,0,.722.735h2.959a.728.728,0,0,0,.735-.722.028.028,0,0,0,0-.013v-3.682H379.11v3.682a.729.729,0,0,0,.722.735h2.958a.729.729,0,0,0,.736-.722v-3.7h.736a.73.73,0,0,0,.736-.722v-5.9a2.218,2.218,0,0,0-1.589-2.121m-20.669-4.386a2.562,2.562,0,0,1,2.385-1.59h13.25a2.593,2.593,0,0,1,2.385,1.59,15.97,15.97,0,0,1,1.178,4.3h-1.415a3.663,3.663,0,0,0-7.184,0H361.562a18.525,18.525,0,0,1,1.178-4.3m16.252,4.3h-4.181a2.207,2.207,0,0,1,2.09-1.473,2.234,2.234,0,0,1,2.091,1.472Zm-16.075,11.775h-1.472v-2.943h1.472Zm19.138,0h-1.473v-2.943h1.472Zm1.472-4.417H359.972v-5.153a.729.729,0,0,1,.723-.735h22.1a.729.729,0,0,1,.736.722v5.166Z" transform="translate(-358.5 -951.615)" fill="#002a3f"/>
                                                        </svg>
                                                        <span>{car_space_count}</span>
                                                    </div>
                                                    <p>{item.description}</p>
                                                    <div className={styles.itemCta}>
                                                        <a href="#" target="_blank">
                                                            <span>Download Homesta</span>
                                                            <img src={require('../images/arrow-right.png').default} alt="Right arrow" />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }

                            </OwlCarousel>

                        </div>
                    </div>
                </div>
                
                <div className={styles.sectionBottomBackground} style={{ backgroundColor: `${bgColorbot}`}}></div>
            </div>
        );

    } else {

        return (
            <div className={styles.sectionLatestListing} style={{ backgroundColor: `${bgcolor}`}}>
                <div className={styles.sectionBottomBackground} style={{ backgroundColor: `${bgColorbot}`}}></div>
            </div>
        );

    }
}
  
export default LatestListing;